import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';


// Directive
@Directive({
    selector: '[appResizer]',
})
export class ResizerDirective implements OnInit {

    public constructor(public element: ElementRef<HTMLElement>) { }

    public ngOnInit(): void {
        this.detectResize();
    }

    @HostListener('window:resize')
    public detectResize(): void {
    }
}
